import React, {useCallback, useContext, useRef} from 'react';
import UserContext from '../../common/UserContext';

// react strap
import {Col, Row} from 'reactstrap';

// kendo react
import {Tooltip} from '@progress/kendo-react-tooltip';
import {Checkbox} from "@progress/kendo-react-inputs";

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    mainMessages,
    downloadLicensesKey, loadingGenerationKey,
} from '../../../assets/text/MultilingualText';
import {PopoverContext} from "./LicenseDownload";
import {Loader} from "@progress/kendo-react-indicators";
import {downloadLicenses} from "../../common/utilities";
import {DownloadIcon, InfoIcon, WarningErrorIcon} from "../../common/icons";
import {useSupportContext} from "../../common/SupportContext";


export const DownloadPanelBarHeader = (props) => {
    const {
        handleBeforeUnload,
        requestedProducts,
        setRequestedProducts,
        index,
        setIsLoading,
    } = props;
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const { dispatch } = useSupportContext();
    const localization = useLocalization();

    //Sets the popover reference based on mouse over
    const popoverRef = useRef(null);
    const {onMouseOver} = useContext(PopoverContext);

    let host = requestedProducts[index]

    const handleMouseOver = useCallback(() => {
        const icons = host.icons
        onMouseOver({
            show: true,
            popoverRef: popoverRef,
            cloudAlert: icons.cloudAlert,
            specialAlert: icons.specialAlert,
            supportError: icons.supportError,
            generationError: icons.generationError,
            qtyError: icons.qtyError,
            entitlementError: icons.entitlementError,
        });
    }, [onMouseOver, host.icons]);
    const handleMouseOut = useCallback(() => {
        const icons = host.icons;
        onMouseOver({
            show: false,
            popoverRef: popoverRef,
            cloudAlert: icons.cloudAlert,
            specialAlert: icons.specialAlert,
            supportError: icons.supportError,
            generationError: icons.generationError,
            qtyError: icons.qtyError,
            entitlementError: icons.entitlementError,
        });
    }, [onMouseOver, host.icons]);

    return (
        <>
            <Row
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Col
                    style={{
                        flex: '0 0 auto',
                        width: 'auto'
                    }}
                >
                    <div
                        className={"k-h5"}
                        style={{
                            color: 'white',
                            margin: '0'
                        }}
                    >
                        {host.panel_bar_title}
                    </div>
                </Col>
                <Col/>
                
                {host.icons.loading && (
                    <Col
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1,
                        }}
                    >
                        <Tooltip
                            anchorElement="pointer"
                            showCallout={true}
                            parentTitle={true}
                            openDelay={0}
                            filter={(e) => {
                                const classNames = ['k-loader k-loader-md k-loader-primary k-loader-pulsing-2', 'k-loader-segment', 'k-loader-canvas'];
                                if (classNames.includes(e.className)) {
                                    return true;
                                }
                            }}
                        >
                            <div
                                title={localization.toLanguageString(loadingGenerationKey, mainMessages[siteLanguageDefault][loadingGenerationKey])}
                                style={{
                                    paddingBottom: '1px'
                                }}
                            >
                                <Loader
                                    type={'converging-spinner'}
                                    style={{
                                        color: 'white'
                                    }}
                                />
                            </div>
                        </Tooltip>
                    </Col>
                )}
                <Col>
                    <div
                        style={{
                            float: 'right'
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.6rem',
                        }}>
                            {(host.icons.loading || host.icons.download) && (
                                <Checkbox
                                    className={'ksm-panelbar-checkbox'}
                                    value={host.icons.checked}
                                    onClick={(e) => {
                                        requestedProducts[index].icons.checked = e.target.checked
                                        setRequestedProducts(JSON.parse(JSON.stringify(requestedProducts)))
                                    }}
                                />
                            )}
                            {host.icons.download && (
                                <Tooltip
                                    anchorElement="pointer"
                                    showCallout={true}
                                    parentTitle={true}
                                    openDelay={0}
                                >
                                    <div
                                        title={localization.toLanguageString(downloadLicensesKey, mainMessages[siteLanguageDefault][downloadLicensesKey])}
                                        onClick={() => {
                                            let eaAllocIds = []
                                            host.products.forEach(product => {
                                                eaAllocIds.push(product.ea_alloc_id.toString())
                                            })
                                            dispatch({ type: 'UPDATE_TRANSACTION', payload: {lic_action: 'download single host'}});
                                            downloadLicenses(eaAllocIds, accessToken, setIsLoading, handleBeforeUnload, "ENTERPRISE_AGREEMENTS");
                                        }}
                                    >
                                        <DownloadIcon
                                            size={'medium'}
                                            style={{
                                                color: 'white',
                                                marginTop: '0.35rem',
                                                marginLeft: '0.35rem',
                                                marginRight: '0.35rem',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                            {(host.icons.supportError || host.icons.generationError || host.icons.qtyError || host.icons.entitlementError) &&
                                !host.icons.download && !host.icons.cloudAlert && (
                                    <div
                                        onMouseOver={handleMouseOver}
                                        onMouseOut={handleMouseOut}
                                        ref={popoverRef}
                                    >
                                        <WarningErrorIcon
                                            size={'medium'}
                                            style={{
                                                color: 'var(--keysight-pink)',
                                                marginTop: '0.35rem',
                                                marginLeft: '0.35rem',
                                                marginRight: '0.35rem',
                                            }}
                                        />
                                    </div>
                                )}
                            {(host.icons.cloudAlert || host.icons.specialAlert) && (
                                <div
                                    onMouseOver={handleMouseOver}
                                    onMouseOut={handleMouseOut}
                                    ref={popoverRef}>
                                    <InfoIcon
                                        size={'medium'}
                                        style={{
                                            color: 'white',
                                            marginTop: '0.35rem',
                                            marginLeft: '0.35rem',
                                            marginRight: '0.35rem',
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}